export const TURNSTILE_SITE_KEY = '0x4AAAAAAA-wFNpU7mZhDp4F'
